// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as VehicleRepoManager from "../../../../library/data-source/vehicle/repo/VehicleRepoManager.bs.js";
import * as GeoRegionRepoManager from "../../../../library/data-source/geo-region/repo/GeoRegionRepoManager.bs.js";
import * as PricingDashboardRepoManager from "./PricingDashboardRepoManager.bs.js";

function fetchCampaigns(geo_region_id, vehicle_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getPricingRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchPricingCampaigns, geo_region_id, vehicle_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchGeoRegions(onSuccessCb, onErrorCb, country) {
  var RepoInstance = GeoRegionRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchGeoRegions, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchVehicleTypes(geo_region_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = VehicleRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchVehicleTypes, geo_region_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchUserRole(onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getUserRoleRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchUserDetails, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchModifications(campaign_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getModificationRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchModifications, campaign_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchZones(geo_region_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getZonesAndClustersRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchZones, geo_region_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function fetchClusters(geo_region_id, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getZonesAndClustersRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.fetchClusters, geo_region_id, country);
              }), Curry.__1(onSuccessCb), Curry.__1(onErrorCb));
}

function createModification(payload, iso_code, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getModificationRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.createModification, payload, iso_code, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onErrorCb));
}

function editModification(payload, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getModificationRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.editModification, payload, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onErrorCb));
}

function reprioritizeModification(payload, onSuccessCb, onErrorCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getModificationRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.reprioritizeModification, payload, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onErrorCb));
}

export {
  fetchCampaigns ,
  fetchGeoRegions ,
  fetchVehicleTypes ,
  fetchUserRole ,
  fetchModifications ,
  fetchZones ,
  fetchClusters ,
  createModification ,
  editModification ,
  reprioritizeModification ,
  
}
/* VehicleRepoManager Not a pure module */
